import { Injectable, Injector, ComponentFactoryResolver, Type } from '@angular/core';

import { ModalDialogRef } from './modal-dialog-ref.service';
import { ModalDialogStack } from './modal-dialog-stack.service';

export interface ModalDialogOptions<DialogType> {
    backdrop?: boolean | 'static';
    container?: string;
    injector?: Injector;
    keyboard?: boolean;
    size?: 'sm' | 'lg';
    windowClass?: string;
    data?: Record<keyof DialogType, DialogType[keyof DialogType]>;
}

@Injectable()
export class ModalDialogService {
    constructor(
        private readonly moduleCFR: ComponentFactoryResolver,
        private readonly injector: Injector,
        private readonly modalDialogStack: ModalDialogStack,
    ) {}

    open<ClosedWithType, DialogType>(
        dialogType: Type<DialogType>,
        options: ModalDialogOptions<DialogType> = {},
    ): ModalDialogRef<ClosedWithType, DialogType> {
        return this.modalDialogStack.open(this.moduleCFR, this.injector, dialogType, options);
    }
}
